<template>
  <div>
    <!-- <GlobalTable
      :enableAddButton ="true"
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput
                    label="Owner Name"
                    invalid-feedback="Owner name should be filled"
                    required
                    v-model="$v.ownerForm.name.$model"
                    :is-valid="!$v.ownerForm.name.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CInput
                    label="Email"
                    invalid-feedback="Email should be filled"
                    required
                    v-model="$v.ownerForm.email.$model"
                    :is-valid="!$v.ownerForm.email.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CInput
                    label="Mobile Phone"
                    invalid-feedback="Mobile Phone should be filled"
                    required
                    v-model="$v.ownerForm.mobile_phone.$model"
                    :is-valid="!$v.ownerForm.mobile_phone.$invalid"
                  />
                </CCol>
                <CCol sm="3">
                  <CInput
                    label="Phone Number"
                    required
                    v-model="$v.ownerForm.phone.$model"
                    :is-valid="!$v.ownerForm.phone.$invalid"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3">
                  <CTextarea
                    label="Address"
                    invalid-feedback="Address should be filled"
                    required
                    v-model="$v.ownerForm.address.$model"
                    :is-valid="!$v.ownerForm.address.$invalid"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <label for="description">Description</label>
                  <quill-editor
                    id="description"
                    style="height: 200px; margin-bottom: 70px"
                    :content="content"
                    :options="editorOption"
                    v-model="$v.ownerForm.description.$model"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <br />
                  <div
                    v-if="$v.ownerForm.description.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Description harus di isi.
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.ownerForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import Loading from "@/templates/Loading";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "OwnerFreezer",
  components: { Loading, quillEditor, JqxGrid, TableButton },
  data() {
    return {
      title: "Owner Freezer",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "freezer_owner_code", type: "string" },
          { name: "name", type: "string" },
          { name: "email", type: "string" },
          { name: "mobile_phone", type: "string" },
          { name: "phone", type: "string" },
          { name: "address", type: "string" },
          { name: "description", type: "string" },
          { name: "status_name", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,
      fields: [
        {
          datafield: "freezer_owner_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Freezer Owner Code",
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Owner Name",
          width: 120,
        },
        {
          datafield: "email",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Email",
        },
        {
          datafield: "mobile_phone",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Mobile Phone",
        },
        {
          datafield: "phone",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Phone Number",
        },
        {
          datafield: "address",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Address",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Description",
        },
        {
          datafield: "status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
          cellsalign: "center",
          align: "center",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      listBoxSource: [
        {
          label: "Phone",
          value: "phone",
          checked: true,
        },
        {
          label: "Description",
          value: "description",
          checked: true,
        },
      ],
      ownerForm: tableInterfaces.freezer_owner,
      items: null,
      isLoading: false,
      isEdit: false,
      addButton: false,
      editorOption: {}, // data quill
      content: "",
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    ownerForm: {
      freezer_owner_code: {},
      name: { required },
      email: { required },
      mobile_phone: { required },
      phone: {required},
      address: { required },
      description: {},
      status: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      // this.cancelForm();
      this.getOwnerListing();
    },
    getOwnerListing: function () {
      this.isLoading = true;
      this.axios
        .get("console/freezer_owner/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            // console.log(response.data)
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this Seller ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/freezer_owner/add", this.ownerForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({
                path: path[2] + "/detail/" + response.data.id,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.productForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.freezer_owner) {
        tableInterfaces.freezer_owner[i] = null;
      }
      this.ownerForm = tableInterfaces.freezer_owner;
    },
    getDropdown: function () {
      // console.log(this.agentForm.parent)
      if (this.agentForm.parent_flag === "2") {
        this.axios.get("/console/dropdown/agent_parent").then((response) => {
          // console.log(response)
          this.parentList = response.data.data;
        });
      }
    },
    onParentChange: function (event) {
      this.getDropdown();
      this.agentForm.parent = null;
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.ownerForm.description = html;
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
